import AgencyRole from "./AgencyRole.js";

/**
 * `DirectorRole` describes permissions of a director over other users.
 */
export default class DirectorRole extends AgencyRole {
	canDeleteUser(user) {
		return user
			.getRoles()
			.every((role) => role.canBeDeletedByDirector(this));
	}

	canAttachOrDetachCompanyId(user, companyId) {
		return user
			.getRoles()
			.some((role) =>
				role.canCompanyIdBeAttachedOrDetachedByDirector(
					this,
					companyId,
				),
			);
	}

	canEditUserInfo(user) {
		return user
			.getRoles()
			.some((role) => role.canUserInfoBeEditedByDirector(this));
	}

	canViewAccountingDocuments(company) {
		return company.getAgencyId() === this.getAgencyId();
	}

	canManagePackages() {
		return true;
	}

	canAdministrateAgency(agency) {
		return agency.getId() === this.getAgencyId();
	}

	canChangeCompanyPackage(company) {
		return company.getAgencyId() === this.getAgencyId();
	}

	//
	// canUpgradeSubscriptionPlan
	//

	canUpgradeSubscriptionPlanForCompany(company) {
		return company.getAgencyId() === this.getAgencyId();
	}

	canExtractDataFromCompany(company) {
		return this.getAgencyId() === company.getAgencyId();
	}

	canDeleteCompany(company) {
		if (company.isProvisionedByOneClick()) return false;

		return this.getAgencyId() === company.getAgencyId();
	}

	canShareChartOfAccounts() {
		return true;
	}
}
